import { createContext, useContext } from 'react';
import { ICitation, ICitationPermissions } from '@vivli/shared/features/citations/infrastructure/interface';
import { Subject } from 'rxjs';

interface ICitationsContext {
    isStudy?: boolean;
    citation?: ICitation;
    isLoading: boolean;
    setIsLoading: (isLoading: boolean) => void;
    citations: ICitation[];
    setCitation: React.Dispatch<React.SetStateAction<ICitation>>;
    objectId: string;
    showDisclosureLinks?: boolean;

    removeCitation(id: string): void;

    /*object id is the document id of the data request or study that "owns" the citation*/
    addCitation(citationDoi: string, citation: ICitation): Subject<ICitation>;

    updateCitation(citation: ICitation): void;

    defaultCitation: ICitation;

    permissions: ICitationPermissions;
}

export const CitationsContext = createContext<ICitationsContext>(null);

export const useCitationsContext = () => useContext(CitationsContext);
